/**
 * @generated SignedSource<<393086c2ea923b4c3032df87b76fb404>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserRoleEnum = "ADMIN" | "CLINICAL_SUPERVISOR" | "EMPLOYEE" | "EXTERNAL_CLINICAL_SUPERVISOR" | "IMPERSONATOR" | "MANAGER" | "MENTOR" | "MHP" | "ORGANISATION_ADMIN" | "UNKNOWN";
export type UserStatusEnum = "ACTIVE" | "DELETED" | "SUSPENDED";
export type UserSelectorQuery$variables = {
  includeOlivans?: boolean | null | undefined;
  search?: string | null | undefined;
};
export type UserSelectorQuery$data = {
  readonly users: {
    readonly nodes: ReadonlyArray<{
      readonly email: string;
      readonly id: string;
      readonly name: string;
      readonly role: ReadonlyArray<UserRoleEnum>;
      readonly status: UserStatusEnum;
      readonly surname: string;
    }>;
  };
};
export type UserSelectorQuery = {
  response: UserSelectorQuery$data;
  variables: UserSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOlivans"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 20
      },
      {
        "kind": "Variable",
        "name": "includeOlivans",
        "variableName": "includeOlivans"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "users",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSelectorQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserSelectorQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "15ec9b48c1ae864cd98d846537090fc6",
    "id": null,
    "metadata": {},
    "name": "UserSelectorQuery",
    "operationKind": "query",
    "text": "query UserSelectorQuery(\n  $search: String\n  $includeOlivans: Boolean\n) {\n  users(first: 20, search: $search, includeOlivans: $includeOlivans) {\n    nodes {\n      id\n      name\n      surname\n      email\n      status\n      role\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "beae41e215b360e688df51d3d8d1870d";

export default node;
